export const scaleData = [
  {
    title: "1/144 HG",
    subtitle: "High Grade",
    description:
      "Hoàn hảo cho người mới bắt đầu. Giá cả phải chăng, dễ lắp ráp và chi tiết cao. Chiều cao trung bình: 12–13cm.",
    skill: "Người mới bắt đầu",
    price: "₫350,000–₫700,000",
  },
  {
    title: "1/144 RG",
    subtitle: "Real Grade",
    description:
      "Khung bên trong tiên tiến với chi tiết đáng kinh ngạc trong kích thước nhỏ gọn. Hoàn hảo cho những người xây dựng có kinh nghiệm.",
    skill: "Trung cấp",
    price: "₫600,000–₫1,400,000",
  },
  {
    title: "1/100 MG",
    subtitle: "Master Grade",
    description:
      "Tiêu chuẩn vàng của Gunpla. Khung bên trong đầy đủ, khớp nối tuyệt vời. Chiều cao trung bình: 18cm.",
    skill: "Trung cấp đến Nâng cao",
    price: "₫700,000–₫1,900,000",
  },
  {
    title: "1/60 PG",
    subtitle: "Perfect Grade",
    description:
      "Trải nghiệm Gunpla tối thượng. Kích thước khổng lồ, đơn vị LED và kỹ thuật đáng kinh ngạc. Cao 30cm+.",
    skill: "Nâng cao",
    price: "₫1,900,000–₫6,000,000",
  },
];
